import React, { useEffect } from "react";
import LabelValueRow from "../../LabelValueRow";

const TaxTotal = ({ fatturato, taxRateTotale, netto, setNetto }) => {
  useEffect(() => {
    if (fatturato !== 0) {
      setNetto(fatturato - fatturato * (taxRateTotale / 100));
    } else {
      setNetto(0);
    }
  }, [fatturato, taxRateTotale, setNetto]);

  return (
    <div className="mt-2">
      <LabelValueRow
        label={"Totali tasse"}
        value={`${(fatturato !== 0 ? fatturato : 1) * (taxRateTotale / 100)}`}
        important={true}
      />
      <LabelValueRow
        label={"Totali guadagni (Utile al netto delle tasse)"}
        value={`${netto}`}
        important={true}
      />
    </div>
  );
};

export default TaxTotal;
